module.exports = __webpack_public_path__ + "static/media/den-gamle-rover-mixed.25b73668.mp3";